import {
  STORAGE_BOX_BIN_LABEL,
  STORAGE_BOX_FAVORITES_LABEL,
  STORAGE_BOX_ROOT_LABEL,
  STORAGE_BOX_LOCK_LABEL,
} from '../constants';
import { buildSharedLockBreadcrumbTrail } from './sharedLockBreadcrumbs';
import { colorTagDisplayName } from './itemMetaDisplay';

/**
 * Folder path where a new or edited text file is stored (display segments joined with " / ").
 */
export function buildStorageBoxEditorSaveLocationPath({
  browseMode,
  breadcrumbs,
  lockRootItemId,
  activeSharedShare,
  readOnly,
  activeLabel,
  activeColorTag,
}) {
  const crumbs = breadcrumbs || [];
  const inBin = browseMode === 'bin';
  const inSharedLockView = browseMode === 'shared' && Boolean(activeSharedShare);
  const inLock = browseMode === 'lock' || browseMode === 'shared';

  if (readOnly) {
    return 'Shared with you';
  }
  if (inBin) {
    return crumbs.length ? `${STORAGE_BOX_BIN_LABEL} / ${crumbs.map((b) => b.name).join(' / ')}` : STORAGE_BOX_BIN_LABEL;
  }
  if (browseMode === 'favorites') {
    return crumbs.length
      ? `${STORAGE_BOX_FAVORITES_LABEL} / ${crumbs.map((b) => b.name).join(' / ')}`
      : STORAGE_BOX_FAVORITES_LABEL;
  }
  if (browseMode === 'label' && activeLabel) {
    return crumbs.length ? `${activeLabel} / ${crumbs.map((b) => b.name).join(' / ')}` : activeLabel;
  }
  if (browseMode === 'colorTag' && activeColorTag) {
    const tagLabel = `Tag: ${colorTagDisplayName(activeColorTag)}`;
    return crumbs.length ? `${tagLabel} / ${crumbs.map((b) => b.name).join(' / ')}` : tagLabel;
  }
  if (inSharedLockView) {
    return buildSharedLockBreadcrumbTrail(activeSharedShare, crumbs, lockRootItemId)
      .map((c) => c.name)
      .join(' / ');
  }
  if (inLock) {
    if (!crumbs.length) return STORAGE_BOX_LOCK_LABEL;
    return crumbs.map((b) => b.name).join(' / ');
  }
  if (!crumbs.length) return STORAGE_BOX_ROOT_LABEL;
  return [STORAGE_BOX_ROOT_LABEL, ...crumbs.map((b) => b.name)].join(' / ');
}

/** Keep start and end of a long path; ellipsis in the middle. */
export function ellipsizeMiddle(text, maxLength) {
  const raw = String(text || '');
  const max = Math.max(12, maxLength || 48);
  if (raw.length <= max) return raw;
  const ellipsis = ' … ';
  const budget = max - ellipsis.length;
  if (budget < 4) return raw.slice(0, max - 1) + '…';
  const head = Math.ceil(budget * 0.42);
  const tail = Math.floor(budget * 0.58);
  return `${raw.slice(0, head)}${ellipsis}${raw.slice(raw.length - tail)}`;
}
